/**
 * @desc 仓库列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/warehouse/listAll`, {
      method: "GET",

      ...options,
    }),
  );
}
